<div class="flex-header sis-app-header-label" style="font-weight:bold; font-size:20px;" translate>
    Filter
</div>

<div class="flex-content">
    <div>
        <label translate>Due Date</label>
        <div>
            <tyl-datepicker style="margin-left: 10px; width: 45%;" id="fromDueDate" label='From'
                [attr.aria-label]="'from due date input ' + (filterParam.FromDueDate ? 'value ' + filterParam.FromDueDate : 'no value')"
                [(value)]="filterParam.FromDueDate" (valueChange)="filterChangeByModel();">
            </tyl-datepicker>
            <tyl-datepicker style="margin-left: 10px; width: 45%;" id="toDueDate" label='To'
                [attr.aria-label]="'to due date input ' + (filterParam.ToDueDate ? 'value ' + filterParam.ToDueDate : 'no value')"
                [(value)]="filterParam.ToDueDate" (valueChange)="filterChangeByModel();">
            </tyl-datepicker>
        </div>
    </div>

    <div>
        <label translate>Assigned Date</label>
        <div>
            <tyl-datepicker style="margin-left: 10px; width: 45%;" id="fromAssignedDate" label='From'
                [attr.aria-label]="'from assigned date input ' + (filterParam.FromAssignedDate ? 'value ' + filterParam.FromAssignedDate : 'no value')"
                [(value)]="filterParam.FromAssignedDate" (valueChange)="filterChangeByModel();">
            </tyl-datepicker>

            <tyl-datepicker style="margin-left: 10px; width: 45%;" id="toAssignedDate" label='To'
                [attr.aria-label]="'to assigned date input ' + (filterParam.ToAssignedDate ? 'value ' + filterParam.ToAssignedDate : 'no value')"
                [(value)]="filterParam.ToAssignedDate" (valueChange)="filterChangeByModel();">
            </tyl-datepicker>
        </div>
    </div>
    <div *ngIf="ShowByClass && showPercentage" style="margin-bottom: 25px;">
        <label translate>Percentage</label>
        <div>
            <tyl-form-field style="margin-left: 10px; width: 45%;" label='From'>
                <input matInput
                    [attr.aria-label]="'from percentage ' + (filterParam.FromPercentage ? 'value ' + filterParam.FromPercentage : 'no value')"
                    id="txtFromPercentage" [(ngModel)]="filterParam.FromPercentage"
                    (ngModelChange)="filterChangeByModel();" type="number" min="0" />
            </tyl-form-field>

            <tyl-form-field style="margin-left: 10px; width: 45%;" label='To'>
                <input matInput
                    [attr.aria-label]="'to percentage ' + (filterParam.ToPercentage ? 'value ' + filterParam.ToPercentage : 'no value')"
                    id="txtToPercentage" [(ngModel)]="filterParam.ToPercentage" (ngModelChange)="filterChangeByModel();"
                    type="number" min="0" />
            </tyl-form-field>
        </div>
    </div>
    <div *ngIf="!ShowByClass">
        <tyl-form-field style="margin-left: 10px; width:93%;" label='Course Name'>
            <mat-select id="dropdownCourses" aria-label="Courses dropdown" placeholder="Select Course" tabindex="0"
                [(ngModel)]="filterParam.Course" (selectionChange)="filterChangeByModel()">
                <mat-option translate></mat-option>
                <mat-option *ngFor="let course of courses" [value]="course">
                    {{ course }}
                </mat-option>
            </mat-select>
        </tyl-form-field>
    </div>
    <div *ngIf="!ShowByClass">
        <tyl-form-field style="margin-left: 10px; width:93%;" label='Term'>
            <mat-select id="dropdownGradingPeriod" aria-label="Grading Period dropdown"
                placeholder="Select Grading Period" tabindex="1" [(ngModel)]="filterParam.Term"
                (selectionChange)="filterChangeByModel()">
                <mat-option translate></mat-option>
                <mat-option *ngFor="let gp of courseTerms" [value]="gp">
                    {{ gp }}
                </mat-option>
            </mat-select>
        </tyl-form-field>
    </div>
    <div>
        <tyl-form-field style="margin-left: 10px; width:93%;" label='Category'>
            <input matInput
                [attr.aria-label]="'Category ' + (filterParam.Category ? 'value ' + filterParam.Category : 'no value')"
                id="txtCategory" [(ngModel)]="filterParam.Category" (ngModelChange)="filterChangeByModel();"
                type="text" />
        </tyl-form-field>
    </div>
    <div>
        <tyl-form-field *ngIf="ShowByClass" style="margin-left: 10px; width:93%;" label='Grade'>
            <input matInput
                [attr.aria-label]="'Grade ' + (filterParam.Grade ? 'value ' + filterParam.Grade : 'no value')"
                id="txtGrade" [(ngModel)]="filterParam.Grade" (ngModelChange)="filterChangeByModel();" type="text" />
        </tyl-form-field>
    </div>
</div>

<div class="filter-flex-footer">
    <!-- Left Buttons -->
    <tyl-button image="startover.png" label="Clear" (clickEvent)="clearFilter()"></tyl-button>

    <!-- Right Buttons -->
    <div class="footerRight">
        <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeFilter()"></tyl-button>
    </div>
</div>